import React, { createContext, useRef, useState } from 'react'
import { Toast } from 'primereact/toast'
import _ from 'lodash'
interface ToastContextType {
  showSuccess: (message: string) => void
  showInfo: (message: string) => void
  showWarn: (message: string) => void
  showError: (message: string) => void
  showSecondary: (message: string) => void
  showContrast: (message: string) => void
}

export const ToastContext = createContext<ToastContextType>({
  showSuccess: () => {},
  showInfo: () => {},
  showWarn: () => {},
  showError: () => {},
  showSecondary: () => {},
  showContrast: () => {},
})

const ToastComponentController = (props: {
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>
}) => {
  const toast = useRef<any>(null)

  const showToast = (severity: any, message: any) => {
    if (toast.current) toast.current.clear()
    toast.current.show({
      severity: severity,
      summary: severity.toUpperCase(),
      detail: message,
      life: 2000,
    })
  }

  const showSuccess = useRef(
    _.debounce((message) => {
      showToast('success', message)
    }, 500),
  ).current

  const showInfo = useRef(
    _.debounce((message) => {
      showToast('info', message)
    }, 500),
  ).current

  const showWarn = useRef(
    _.debounce((message) => {
      showToast('warn', message)
    }, 500),
  ).current

  const showError = useRef(
    _.debounce((message) => {
      showToast('error', message)
    }, 500),
  ).current

  const showSecondary = useRef(
    _.debounce((message) => {
      showToast('secondary', message)
    }, 500),
  ).current

  const showContrast = useRef(
    _.debounce((message) => {
      showToast('contrast', message)
    }, 500),
  ).current

  return (
    <ToastContext.Provider
      value={{
        showSuccess,
        showInfo,
        showWarn,
        showError,
        showSecondary,
        showContrast,
      }}
    >
      <Toast ref={toast} />
      {props.children}
    </ToastContext.Provider>
  )
}

export default ToastComponentController
